module.exports = __webpack_public_path__ + "img/default-shop.1c743d9f.png";